import React from "react";
import { Text, Box, Checkbox, Flex, ListItem } from "@chakra-ui/react";
import {
  getFormSubmission,
  deleteFormSubmission,
} from "../../api/formSubmissionApi";
import JSONPretty from "react-json-pretty";
const actionTypes = {
  view: "view",
  delete: "delete",
};

const FormListItem = ({
  column1,
  column2,
  id,
  created,
  handleAction,
  onChangeCheckBox,
  isChecked,
  allChecked,
}) => {
  const handleOnClick = (type) => {
    switch (type) {
      case actionTypes.delete: {
        deleteFormSubmission(id).then(() => {
          handleAction(id);
        });
        return;
      }
      case actionTypes.view: {
        return handleAction(id, actionTypes.view);
      }
    }
  };
  return (
    <ListItem className="form-list-item" w="100%">
      <Flex justify="space-between" w="100%">
        <Box p="3" w="30%">
          <Flex alignItems="center">
            <Checkbox
              pr="12px"
              name={id}
              key={id}
              isChecked={allChecked ? true : isChecked[id]}
              onChange={(e) => {
                onChangeCheckBox(e, id);
              }}
            ></Checkbox> 
            <Box p="12px">{column1.length && typeof column1!="string"? 
          <JSONPretty id="json-pretty" data={column1} /> :(
            column1.length > 30
                ? column1.slice(0, 27)+"..."
                : column1 || ""
                )}</Box>
          </Flex>
        </Box>
        <Box p="3" w="30%" >
        <Flex  alignItems="center">
        <Box ml="4%" className="form-list-item__actions" p="12px">{column2.length && typeof column2!="string"? 
          <JSONPretty id="json-pretty" data={column2} /> :(
            column2.length > 30
                ? column2.slice(0, 27)+"..."
                : column2 || ""
                )}</Box></Flex>
        </Box>
        <Box p="3" w="10%">
          <Flex ml="1" className="form-list-item__actions" alignItems="center"> <Box p="12px">{created}</Box></Flex>
        </Box>
        <Box p="3" w="30%">
          <Flex ml="1" className="form-list-item__actions" alignItems="center">
            <span onClick={() => handleOnClick(actionTypes.view)}>View</span>
            {"|"}
            <span
              className="delete-action"
              onClick={() => handleOnClick(actionTypes.delete)}
            >
              Delete
            </span>
          </Flex>
        </Box>
      </Flex>
    </ListItem>
  );
};

export default FormListItem;
